import makeStyles from '@material-ui/core/styles/makeStyles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ExpandMore  from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      width: '100%',
      height: '40px',
      color: colors.grey.dark,
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      },
      '&:hover': {
        color: colors.primary.main
      }
    },
    input: {
      border: `2px solid ${colors.grey.medium}`,
      borderRadius: '4px',
      paddingLeft: '16px',
      boxSizing: 'border-box',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        borderColor: colors.accent.main
      },
      '&:focus': {
        backgroundColor: colors.white,
        borderRadius: '4px'
      }
    },
    icon: {
      color: 'inherit',
      right: '8px'
    },
    optionsListContainer: {
      border: `2px solid ${colors.primary.main}`,
      boxSizing: 'content-box',
      paddingRight: '1px',
      '& .Mui-selected': {
        backgroundColor: colors.white,
        color: colors.grey.dark,
        '&:hover': {
          backgroundColor: colors.primary.light,
          color: colors.accent.main
        }
      },
      '& .Mui-disabled': {
        opacity: '1',
        color: colors.primary.main
      }
    },
    optionsList: {
      paddingTop: '0',
      paddingBottom: '0',
      '& li': {
        fontSize: '.925rem',
        color: colors.grey.dark
      },
      '& li:first-child': {
        height: '38px'
      },
      '& li:focus': {
        backgroundColor: 'inherit'
      },
      '& li:hover': {
        backgroundColor: colors.primary.light,
        color: colors.accent.main
      }
    },
    label: {
      fontSize: '.85rem'
    }
  };
});

const DropdownInput = ({ options, label, selected, onSelect }) => {
  const classes = useStyles();

  const renderedOptions = options.map(option => (
    <MenuItem key={option.value} value={option.value} onClick={() => onSelect(option)}>
      {option.label}
    </MenuItem>
  ));

  return (
    <Select
      displayEmpty
      value={(selected && selected.value) || ''}
      className={classes.root}
      classes={{
        root: classes.input,
        icon: classes.icon
      }}
      IconComponent={ExpandMore}
      MenuProps={{
        classes: {
          paper: classes.optionsListContainer,
          list: classes.optionsList
        }
      }}
      renderValue={() =>
        (selected && selected.label) || <span className={classes.label}>{label}</span>
      }
    >
      <MenuItem disabled>
        <span className={classes.label}>{label}</span>
      </MenuItem>
      {renderedOptions}
    </Select>
  );
};

DropdownInput.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  label: PropTypes.string,
  selected: PropTypes.exact({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  onSelect: PropTypes.func.isRequired
};

DropdownInput.defaultProps = {
  label: 'Choose item(s)...',
  selected: null
};

export default DropdownInput;
